import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicTransactionSmall({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.66 9.02a.84.84 0 110 1.68H6.03l.78 1.06a.84.84 0 11-1.35 1l-1.8-2.4a.84.84 0 01.69-1.34zm-2.3-5.85c.37-.28.9-.2 1.18.17l1.8 2.4a.84.84 0 01-.69 1.35h-7.3a.84.84 0 010-1.7h5.62L9.2 4.36a.84.84 0 01.17-1.18z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicTransactionSmall.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicTransactionSmall.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicTransactionSmall svgRef={ref} {...props} />
));
export default ForwardRef;
